import { render, staticRenderFns } from "./notification-container.vue?vue&type=template&id=d7c8f6e2"
import script from "./notification-container.vue?vue&type=script&lang=js"
export * from "./notification-container.vue?vue&type=script&lang=js"
import style0 from "./notification-container.vue?vue&type=style&index=0&id=d7c8f6e2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports